import requests from "utils/httpService";
import { MERCHANT_THEME } from "constants/keys";
import { emsInstance } from "utils/httpService";

const postRequests = {
  getTokenWithLoyaltyConfig: async (values) => {
    try {
      const { mod_by, merchant_id } = values;
      const merchantTheme = sessionStorage.getItem(MERCHANT_THEME);
      const merchantThemeParsed = JSON?.parse(merchantTheme);
      if (merchantThemeParsed?.merchant_id !== merchant_id) {
        const response = await emsInstance.post("/jwt/sign", {
          application: "IPAYPOS",
          mod_by,
          merchant_id,
        });
        const token = response.data.token;
        localStorage.setItem("emsToken", token);
        const merchantStoreConfig = await emsInstance.get(
          `/loyalties/merchants/loyalty`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return merchantStoreConfig;
      }
      const token = localStorage.getItem("emsToken");
      const merchantStoreConfig = await emsInstance.get(
        `/loyalties/merchants/loyalty`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return merchantStoreConfig;
    } catch (error) {
      console.error("Error fetching token:", error);
    }
  },
  getLoyaltyConfigBySlug: async (values) => {
    try {
      const { mod_by, merchant_id, slug } = values;
      const response = await emsInstance.post("/jwt/sign", {
        application: "IPAYPOS",
        mod_by,
        merchant_id,
      });
      const token = response.data.token;
      localStorage.setItem("emsToken", token);
      const merchantStoreConfig = await emsInstance.get(
        `/loyalties/merchants/loyalty/${slug}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return merchantStoreConfig;
    } catch (error) {
      console.error("Error fetching token:", error);
    }
  },
  registerLoyaltyUser: (values) =>
    requests.manageServiceRequests.post("/customers/register", values),
  loginUser: (values) =>
    requests.manageServiceRequests.post(`/customers/login`, values),
  redeemAirtime: (values) =>
    requests.manageServiceRequests.post("/topups/process", values),
  redeemVoucher: (values) =>
    requests.manageServiceRequests.post("/orders/voucher/process", values),
  redeemTicket: (values) =>
    requests.manageServiceRequests.post(
      `/tickets/request/process/customer`,
      values
    ),
  processPayment: (values, headers) =>
    requests.manageServiceRequests.post("/orders/payment/process", values, {
      headers,
    }),
  cancelPayment: (values) =>
    requests.manageServiceRequests.post("/payments/cancel", values),
  addPaymentWallet: (values) =>
    requests.manageServiceRequests.post(
      "/customers/customer/property/wallets",
      values
    ),
  raiseOrderVoucher: (values) =>
    requests.manageServiceRequests.post("/orders/voucher/process", values),
  raiseOrder: (values) =>
    requests.manageServiceRequests.post("/orders/order/process", values),
  sendData: (values) =>
    requests.manageServiceRequests.post("notifications/send", values),
};

export default postRequests;
